export default function cleanPolygonData(data = []) {
  return data.filter(item => {
    if(!(item.x == 0 && item.y == 0)) {
      return item
    }
  })
}